import { IoClose } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import {
  Animatespin,
  HoverButton,
  SearchbarCom,
  SidenavbarCom,
  PostListTable,
  Pagination,
} from "../../components";
import Functions from "./index.function";
export default function JobList() {
  const {
    jobslisting,
    navigate,
    setActiveTab,
    activeTab,
    isLoading,
    loadingToapi,
    setCurrentPage,
    currentPage,
    total_pages,
    has_more_pages,
    confirmDeleteJob,
    setConfirmDeleteJob,
    jobIdToDelete,
    setJobIdToDelete,
    handleDeleteJob,
  } = Functions();
  return (
    <div className="h-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 w-full xs:px-1 sm:pl-4 lg:pl-5 scroll-container h-[calc(100vh-4rem)] pt-2 pb-1">
          <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
            <>
              <div className="flex items-center justify-between py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-lg font-onestSemiBold">
                  Posting list
                </h1>
                <div className="flex items-center xs:gap-x-1 sm:gap-x-2">
                  <div
                    className="bg-[#D9A239] cursor-pointer flex items-center xs:gap-x-1.5 sm:gap-x-2.5 lg:gap-x-3 text-secondary xs:text-[10px] sm:text-sm lg:text-base rounded-full xs:px-2 xs:py-1 sm:px-3 sm:py-2 lg:px-4 lg:py-3 font-onestRegular transform transition-transform duration-300 hover:scale-105 hover:bg-[#c59632]"
                    onClick={() => navigate("/create-job")}
                  >
                    <FaPlus className="xs:text-base sm:text-lg lg:text-xl" />
                    Create Job
                  </div>
                  <div className="flex items-center bg-[#2A2A2A] xs:gap-x-1 gap-x-2 p-1 rounded-full">
                    <button
                      onClick={() => setActiveTab(1)}
                      type={"button"}
                      className={`group xs:w-18 xs:h-8 sm:w-32 sm:h-10 lg:w-40 ${
                        activeTab === 1 ? `gradient-container_btn` : ""
                      } xl:w-44 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Active Jobs
                      </p>
                    </button>
                    <button
                      onClick={() => setActiveTab(0)}
                      type={"button"}
                      className={`group xs:w-18 xs:h-8 sm:w-32 sm:h-10 lg:w-40 ${
                        activeTab === 0 ? `gradient-container_btn` : ""
                      } xl:w-44 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Inactive Jobs
                      </p>
                    </button>
                  </div>
                </div>
              </div>
            </>
            <div
              className={` ${jobslisting?.jobs?.length < 1 ? "h-full" : ""}`}
            >
              {jobslisting?.jobs?.length < 1 ? (
                <div className="flex flex-col w-full h-full justify-center items-center gap-y-5 sm:gap-y-10">
                  <p className="text-secondary xs:text-base sm:text-lg lg:text-xl xl:text-2xl 2xl:text-4xl font-unboundedMedium">
                    Create Your First Job
                  </p>
                  <div
                    className="bg-[#D9A239] cursor-pointer flex items-center xs:gap-x-1.5 sm:gap-x-2.5 lg:gap-x-3 text-secondary xs:text-[10px] sm:text-sm lg:text-xl rounded-full xs:px-2 xs:py-1 sm:px-3 sm:py-2 lg:px-4 lg:py-3 font-onestRegular transform transition-transform duration-300 hover:scale-105 hover:bg-[#c59632]"
                    onClick={() => navigate("/create-job")}
                  >
                    <FaPlus className="xs:text-base sm:text-lg lg:text-xl" />
                    Create Job
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="flex-1 overflow-y-auto scroll-container">
              {isLoading === true ? (
                <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                  <Animatespin />
                </div>
              ) : (
                <>
                  <div className="">
                    {jobslisting?.jobs?.length > 0 ? (
                      <>
                        {activeTab === 1 && (
                          <div className="">
                            <PostListTable
                              title={[
                                "Company",
                                "Job Title",
                                "Job Type",
                                "Salary From",
                                "Salary To",
                                "Country",
                                <>
                                  Views <br />/ Applied
                                </>,
                                "Favorites",
                                <>
                                  Active
                                  <br />/ Inactive
                                </>,
                                "Actions",
                              ]}
                              data={jobslisting?.jobs}
                              requestTitle={"pending"}
                              loadingToapi={loadingToapi}
                              setJobIdToDelete={setJobIdToDelete}
                              setConfirmDeleteJob={setConfirmDeleteJob}
                            />
                          </div>
                        )}
                        {activeTab === 0 && (
                          <div className="">
                            <PostListTable
                              title={[
                                "Company",
                                "Job Title",
                                "Job Type",
                                "Salary From",
                                "Salary To",
                                "Country",
                                <>
                                  Views <br />/ Applied
                                </>,
                                "Favorites",
                                <>
                                  Active
                                  <br />/ Inactive
                                </>,
                                "Actions",
                              ]}
                              data={jobslisting?.jobs}
                              requestTitle={"pending"}
                              loadingToapi={loadingToapi}
                              setJobIdToDelete={setJobIdToDelete}
                              setConfirmDeleteJob={setConfirmDeleteJob}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              )}
            </div>
            {confirmDeleteJob && (
              <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 z-40">
                <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#151515] xs:p-5 sm:p-8 rounded-3xl h-auto relative ">
                  <div
                    className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
                    onClick={() => setConfirmDeleteJob(false)}
                  >
                    <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                  </div>
                  <div className="flex justify-center items-center flex-col xs:pt-14 sm:pt-16 lg:pt-20 xl:pt-24">
                    <div className="text-center lg:pb-7 xl:pb-14">
                      <h2 className="text-secondary font-josefinSansMedium xs:pb-2 sm:pb-3 lg:pb-5 xs:text-xl sm:text-2xl lg:text-3xl xl:text-4xl">
                        Are you Sure
                      </h2>
                      <p className="text-secondary font-josefinSansLight xs:text-xs sm:text-xs lg:text-sm xl:text-base">
                        Delete the Job
                      </p>
                    </div>
                    <div className="flex justify-center items-center my-10 lg:my-8">
                      <HoverButton
                        onClick={() => handleDeleteJob(jobIdToDelete)}
                        extraClasses={
                          "group xs:w-44 xs:h-10 sm:w-48 sm:h-10 xl:w-64 lg:w-52 cursor-pointer bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                        }
                        BtnTitle={
                          loadingToapi ? (
                            <div className="flex justify-center items-center">
                              <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                            </div>
                          ) : (
                            "Delete Job"
                          )
                        }
                        BtnTitleClasses={
                          "text-secondary font-onestMedium xs:text-sm sm:text-base lg:text-lg xl:text-xl transition-transform transform group-hover:scale-105 group-hover:text-primary"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              className={` ${
                jobslisting?.jobs?.length < 1
                  ? ""
                  : "pt-2.5 sm:pt-5 pb-5 sm:pb-10"
              }`}
            >
              {jobslisting?.total_records > 10 && (
                <div className="flex justify-end items-center">
                  <Pagination
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    total_pages={total_pages}
                    has_more_pages={has_more_pages}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
